import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'

import './style.scss'


export default function A (props) {
  const {className, aType, size, iconName, iconAlign, ...aProps} = props
  const sizeClass = size ? `btn-${size}` : ''
  const classes = `${className || ''} btn btn-${aType} ${sizeClass}`

  const _renderIcon = (iconName) => {
    return !!iconName ? (
      <span className="material-icons">{iconName}</span>
    ) : null
  }

  return (
    <Link className={`Anchor ${classes}`} {...aProps}>
      { iconAlign === 'left' && _renderIcon(iconName) }
      <span>
        {props.children}
      </span>
      { iconAlign === 'right' && _renderIcon(iconName) }
    </Link>
  )
}

A.defaultProps = {
  aType: 'primary',
  iconAlign: 'left',
  iconName: undefined,
  size: undefined // avoid adding .btn-lg
}

A.propTypes = {
  aType: PropTypes.oneOf(['primary', 'secondary', 'link', 'inverse', 'danger', 'primary-inverse']),
  iconAlign: PropTypes.oneOf(['left', 'right']),
  size: PropTypes.string, // big, small, etc
  iconName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/A/index.js